export default __webpack_public_path__ + "static/media/spreadSmall.09b6e92b.png";